import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { AccountConstructorFactory } from '@webapp/platform/finance'
import { OrderItem, type OrderItemConstructorData } from './OrderItem'
import { OrderItemReceiveMethodTypes } from '../enums/OrderItemReceiveMethodEnum'
import { OrderItemStatuses } from '../enums/OrderItemStatusEnum'
import { OrderItemTypes } from '../enums/OrderItemTypeEnum'
import { OrderItemVendorConstructorFactory } from '../OrderItemVendor'

export const OrderItemConstructorFactory =
  Factory.Sync.makeFactory<OrderItemConstructorData>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => faker.random.word()),
    type: OrderItemTypes.ONE_TIME,
    status: OrderItemStatuses.PENDING,
    dateSubmitted: Factory.each(() => faker.date.past().toISOString()),
    dateRequired: Factory.each(() => faker.date.future().toISOString()),
    dateModified: Factory.each(() => faker.date.past().toISOString()),
    account: Factory.each(() => AccountConstructorFactory.build()),
    customFields: [],
    attachments: [],
    sku: Factory.each(() => faker.random.number().toString()),
    comment: Factory.each(() => faker.random.word()),
    vendorComment: null,
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    price: Factory.each(() => faker.commerce.price()),
    quantity: Factory.each(() => faker.random.number()),
    unit: 'each',
    shippingAmount: Factory.each(() => faker.commerce.price()),
    taxAmount: Factory.each(() => faker.commerce.price()),
    totalCost: Factory.each(() => faker.commerce.price()),
    approvedTotalCost: null,
    preferredVendor: Factory.each(() =>
      OrderItemVendorConstructorFactory.build()
    ),
    vendorName: Factory.each(() => faker.random.word()),
    receivingMethod: OrderItemReceiveMethodTypes.QUANTITY,
    blanketItemDetails: null,
    recurringItemDetails: null,
    catalogItemRef: null,
    punchoutSupplier: null,
    punchoutConfirmationStatus: null,
    order: Factory.each(() => ({
      uuid: faker.random.uuid(),
      id: faker.random.number(),
    })),
    purchaseOrder: null,
    receivedQuantity: 0,
    dateFullyReceived: null,
    lineNumber: Factory.each((i) => i + 1),
  })

export const OrderItemFactory = EntityFactory(
  OrderItem,
  OrderItemConstructorFactory
)
